import {
  ID_BACKLIGHT_ATTRIBUTE,
  ID_BODY_MATERIAL_ATTRIBUTE,
  ID_COLLECTION_ATTRIBUTE,
  ID_DEPTH_ATTRIBUTE,
  ID_HEIGHT_ATTRIBUTE,
  ID_WIDTH_ATTRIBUTE
} from '@shared/constants/keys';

import { useCharsManager } from '../../../../../hooks/useCharsManager';
import { CharItem } from '../CharItem/CharItem';

export const MirrorsCabinet = () => {
  const { props, onClickCollectionLink } = useCharsManager();
  return (
    <>
      {props[ID_COLLECTION_ATTRIBUTE] ? (
        <CharItem
          onClick={onClickCollectionLink}
          label={props[ID_COLLECTION_ATTRIBUTE]?.name}
          value={props[ID_COLLECTION_ATTRIBUTE]?.values[0]?.value}
        />
      ) : null}
      {props[ID_WIDTH_ATTRIBUTE] && props[ID_DEPTH_ATTRIBUTE] && props[ID_HEIGHT_ATTRIBUTE] ? (
        <CharItem
          label={'ШхГхВ'}
          value={`${props[ID_WIDTH_ATTRIBUTE]?.values[0]?.value}x${props[ID_DEPTH_ATTRIBUTE]?.values[0]?.value}x${props[ID_HEIGHT_ATTRIBUTE]?.values[0]?.value}`}
        />
      ) : null}
      {props[ID_BACKLIGHT_ATTRIBUTE] ? (
        <CharItem
          label={props[ID_BACKLIGHT_ATTRIBUTE]?.name}
          value={props[ID_BACKLIGHT_ATTRIBUTE]?.values[0]?.value === 'true' ? 'Да' : 'Нет'}
        />
      ) : null}
      {props[ID_BODY_MATERIAL_ATTRIBUTE] ? (
        <CharItem
          label={props[ID_BODY_MATERIAL_ATTRIBUTE]?.name}
          value={props[ID_BODY_MATERIAL_ATTRIBUTE]?.values[0]?.value}
        />
      ) : null}
    </>
  );
};
